<template>
  <lottery-list
    :chance="userInfo.chance"
    :exchange="userInfo.exchange"
    :allCard="allCard"
    :cards="cards"
    @gotoMy="gotoMy"
    @clickLottery="clickLottery"
    @clickPrize="clickPrize"
    @gotoView="gotoView"
  >
    <task-list slot="task"></task-list>
  </lottery-list>
</template>

<script>
import LotteryList from '@this/components/List/Lottery';
import taskList from '@this/connect/List/Task';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('user', ['userInfo', 'cards']),
    ...mapGetters('task', ['taskList']),
    ...mapGetters('config', ['allCard']),
  },
  methods: {
    ...mapActions('lottery', ['clickLottery', 'clickPrize']),
    ...mapActions('goto', ['gotoMy', 'gotoView']),
  },
  components: {
    LotteryList,
    taskList,
  },
};
</script>
